
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/investor/quarterly-results",
      function () {
        return require("private-next-pages/investor/quarterly-results.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/investor/quarterly-results"])
      });
    }
  